import { useState, useCallback } from 'react';

const INITIAL_DATA = [
  {
    id: 1,
    username: 'BountyCorp',
    time: '3:15 PM',
    message: 'Hey are you done yet?',
    avatar: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Felix',
    isLive: true,
  },
  {
    id: 2,
    username: 'DesignTeam',
    time: '2:30 PM',
    message:
      'The new mockups are ready for review.The new mockups are ready for review',
    avatar: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Aneka',
    isLive: false,
  },
  {
    id: 3,
    username: 'John Doe',
    time: '1:45 PM',
    message: 'Can we reschedule our meeting?',
    avatar: 'https://api.dicebear.com/9.x/avataaars/svg?seed=John',
    isLive: true,
  },
  {
    id: 4,
    username: 'Sarah Smith',
    time: '11:20 AM',
    message: 'Thanks for the update!',
    avatar: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Sarah',
  },
  {
    id: 5,
    username: 'Dev Squad',
    time: '10:00 AM',
    message: 'Deployment was successful.',
    avatar: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Dev',
  },
  {
    id: 6,
    username: 'John Doe',
    time: '1:45 PM',
    message: 'Can we reschedule our meeting?',
    avatar: 'https://api.dicebear.com/9.x/avataaars/svg?seed=John',
  },
  {
    id: 7,
    username: 'Sarah Smith',
    time: '11:20 AM',
    message: 'Thanks for the update!',
    avatar: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Sarah',
  },
  {
    id: 8,
    username: 'Dev Squad',
    time: '10:00 AM',
    message: 'Deployment was successful.',
    avatar: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Dev',
  },
];

const useMessages = () => {
  const [messages, setMessages] = useState(INITIAL_DATA);
  const [loading, setLoading] = useState(false);

  const loadMore = useCallback(async () => {
    if (loading) return;
    setLoading(true);

    // Simulate network delay
    await new Promise((resolve) => setTimeout(resolve, 1000));

    const newMessages = Array.from({ length: 5 }).map((_, i) => {
      const id = messages.length + i + 1;
      return {
        id,
        username: `User ${id}`,
        time: '9:00 AM',
        message: `This is older message #${id}`,
        avatar: `https://api.dicebear.com/9.x/avataaars/svg?seed=${id}`,
      };
    });

    setMessages((prev) => [...prev, ...newMessages]);
    setLoading(false);
  }, [messages.length, loading]);

  return { messages, loadMore, loading };
};

export default useMessages;
